import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-holidu-wizard-complete',
  templateUrl: './connect-holidu-wizard-complete.component.html',
  styleUrls: ['./connect-holidu-wizard-complete.component.scss'],
})
export class ConnectHoliduWizardCompleteComponent implements OnInit {
  @Output() done = new EventEmitter()

  ngOnInit(): void {}
}
